
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/need-for-transparency",
      function () {
        return require("private-next-pages/nm/news/need-for-transparency.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/need-for-transparency"])
      });
    }
  